export default __webpack_public_path__ + "static/media/step.b9392a70.wav";